import { render } from "./NewPage.vue?vue&type=template&id=6a69b40a&scoped=true"
import script from "./NewPage.vue?vue&type=script&lang=js"
export * from "./NewPage.vue?vue&type=script&lang=js"

import "./NewPage.vue?vue&type=style&index=0&id=6a69b40a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a69b40a"]])

export default __exports__